import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Научный туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>Данный вид туризма, включающий поездки с целью участия в различных конгрессах, симпозиумах и
                        совещаниях, занимает все большее место в современном международном туризме. По имеющимся
                        оценкам, участники подобных международных мероприятий составляют 6 – 7% общего количества
                        иностранных временных посетителей, и на их долю приходится около 10% валютных поступлений от
                        туризма.</p>
                    <p>Среди видов научного туризма, для Брестчины, особо следует выделить возможности туризма
                        орнитологического.</p>
                </div>
            </div>
        </>
    );
}